// ✅ src/services/roleService.js
import axiosClient from "../api/axiosClient";

// roles under a tenant (includes system roles if your backend returns them)
export const getRolesByTenant = async (tenant_id) => {
  const { data } = await axiosClient.get("/admin/roles/list", {
    params: { tenant_id },
  });
  return data; // { success, data: [ {id,name,code,...}, ... ] }
};
